export const INTERNAL_DOMAINS = [
  'hundo.xyz',
  'play-studio.com'
];